/* tslint:disable */
/* eslint-disable */
/**
 * Melco Tracking APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    TrackingMelcoModelsError,
    TrackingMelcoModelsErrorFromJSON,
    TrackingMelcoModelsErrorToJSON,
    TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummary,
    TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummaryFromJSON,
    TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummaryToJSON,
    TrackingTrackingModelsAnalyticsDownloadAssetDetails,
    TrackingTrackingModelsAnalyticsDownloadAssetDetailsFromJSON,
    TrackingTrackingModelsAnalyticsDownloadAssetDetailsToJSON,
} from '../models';

export interface ControlCenterApiAnalyticAdminDailyDesignSummaryRequest {
    productCode?: string;
    startTimestamp?: Date;
    endTimestamp?: Date;
}

export interface ControlCenterApiAnalyticAdminExportDownloadSummaryRequest {
    productCode?: string;
    startTimestamp?: Date;
    endTimestamp?: Date;
    format?: string;
}

export interface ControlCenterApiTrackDesignDownloadsRequest {
    trackingTrackingModelsAnalyticsDownloadAssetDetails?: TrackingTrackingModelsAnalyticsDownloadAssetDetails;
}

/**
 * 
 */
export class ControlCenterApi extends runtime.BaseAPI {

    /**
     */
    async analyticAdminDailyDesignSummaryRaw(requestParameters: ControlCenterApiAnalyticAdminDailyDesignSummaryRequest): Promise<runtime.ApiResponse<TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummary>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.productCode !== undefined) {
            queryParameters['product_code'] = requestParameters.productCode;
        }

        if (requestParameters.startTimestamp !== undefined) {
            queryParameters['start_timestamp'] = (requestParameters.startTimestamp as any).toISOString();
        }

        if (requestParameters.endTimestamp !== undefined) {
            queryParameters['end_timestamp'] = (requestParameters.endTimestamp as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/analytics/designs/downloads/dailysummary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummaryFromJSON(jsonValue));
    }

    /**
     */
    async analyticAdminDailyDesignSummary(requestParameters: ControlCenterApiAnalyticAdminDailyDesignSummaryRequest): Promise<TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummary> {
        const response = await this.analyticAdminDailyDesignSummaryRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async analyticAdminExportDownloadSummaryRaw(requestParameters: ControlCenterApiAnalyticAdminExportDownloadSummaryRequest): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.productCode !== undefined) {
            queryParameters['product_code'] = requestParameters.productCode;
        }

        if (requestParameters.startTimestamp !== undefined) {
            queryParameters['start_timestamp'] = (requestParameters.startTimestamp as any).toISOString();
        }

        if (requestParameters.endTimestamp !== undefined) {
            queryParameters['end_timestamp'] = (requestParameters.endTimestamp as any).toISOString();
        }

        if (requestParameters.format !== undefined) {
            queryParameters['format'] = requestParameters.format;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/analytics/designs/downloads/dailysummary/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async analyticAdminExportDownloadSummary(requestParameters: ControlCenterApiAnalyticAdminExportDownloadSummaryRequest): Promise<Blob> {
        const response = await this.analyticAdminExportDownloadSummaryRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async trackDesignDownloadsRaw(requestParameters: ControlCenterApiTrackDesignDownloadsRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/analytics/designs/downloads/track`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TrackingTrackingModelsAnalyticsDownloadAssetDetailsToJSON(requestParameters.trackingTrackingModelsAnalyticsDownloadAssetDetails),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async trackDesignDownloads(requestParameters: ControlCenterApiTrackDesignDownloadsRequest): Promise<void> {
        await this.trackDesignDownloadsRaw(requestParameters);
    }

}
